import { Box } from '@mui/material';
import React from 'react';
import FileUploadComponent from '../../../globalComponents/FileUploadComponent';
import { useOcrInputStore } from '../store/ocrInputStore';

interface DataInputInitialViewProps {
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DataInputInitialView: React.FC<DataInputInitialViewProps> = ({ onFileSelect }) => {
  const { selectedAsset, selectedTemplate } = useOcrInputStore();
  const isUploadDisabled = !selectedAsset || !selectedTemplate;

  return (
    <Box sx={{ flex: 1, minHeight: 0 }}>
      <FileUploadComponent accept="image/jpeg,image/png,image/jpg" onFileClick={onFileSelect} disabled={isUploadDisabled} supportiveText = "Supported types: JPG, PNG, JPEG" />
    </Box>
  );
};
